module.exports = __webpack_public_path__ + "media/images/icons/dollar-c77c62b7abb0051e4dbd5ba0949e1e2d.svg";